import React, { useState, useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaIdCard } from "react-icons/fa";
import {
  createEmployeeApi,
  updateEmployeeApi,
} from "../../services/EmployeeService";
import FileUpload from "../Constant/fileupload";
import { FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { GrUserWorker } from "react-icons/gr";
import { FaMoneyBill1Wave } from "react-icons/fa6";
import { useSelector } from "react-redux";
const formatAadhar = (num) => {
  if (!num) return "";
  const digits = num.toString().replace(/\D/g, "");
  return digits.match(/.{1,4}/g)?.join(" ") || "";
};
const AddEmployeeModal = ({ visible, onClose, onAfterSubmit, data = null }) => {
  const [loading, setLoading] = useState(false);
  const userRole = useSelector((state) =>
    state.auth.user?.is_superuser ? "admin" : "user" || "user"
  );
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile_number: "",
    adhar_number: "",
    adhar_image: "",
    base_salary: "",
  });
  const [error, setError] = useState({});

  useEffect(() => {
    if (visible) handleReset();
  }, [visible]);

  const handleReset = () => {
    if (data) {
      setForm({
        name: data?.name || "",
        email: data?.email || "",
        mobile_number: data?.mobile_number || "",
        adhar_number: formatAadhar(data?.adhar_number),
        adhar_image: data?.adhar_image || "",
        base_salary: Number(data?.base_salary) || "",
      });
    } else {
      setForm({
        name: "",
        email: "",
        mobile_number: "",
        adhar_number: "",
        adhar_image: "",
        base_salary: "",
      });
    }

    setError({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobile_number" && value) {
      const numericValue = value.replace(/[^0-9]/g, "");
      setForm((prev) => ({ ...prev, [name]: numericValue }));

      if (numericValue.length === 10) {
        if (error?.mobile_number) {
          setError((prev) => ({ ...prev, mobile_number: "" }));
        }
      } else {
        setError((prev) => ({ ...prev, mobile_number: "Must be 10 digits" }));
      }
    } else if (name === "email" && value) {
      const emailValue = value;
      const emailRegex = /^\S+@\S+\.\S+$/;
      setForm((prev) => ({ ...prev, [name]: emailValue }));
      if (emailRegex.test(emailValue)) {
        if (error?.email) {
          setError((prev) => ({ ...prev, email: "" }));
        }
      } else {
        setError((prev) => ({
          ...prev,
          email: "Invalid email format",
        }));
      }
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
      if (error?.[name]) {
        setError((prev) => ({ ...prev, [name]: "" }));
      }
    }
  };

  const handleSubmit = () => {
    let error = {};

    if (!form.name?.trim()) {
      error.name = "Name is required";
    }
    if (!form.mobile_number?.trim()) {
      error.mobile_number = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.mobile_number)) {
      error.mobile_number = "Enter a valid 10-digit mobile number";
    }
    if (form.email?.trim()) {
      if (
        !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(form.email)
      ) {
        error.email = "Enter a valid email address";
      }
    }

    if (!form.adhar_number?.trim()) {
      error.adhar_number = "Aadhar Number is required";
    } else if (!/^\d{4}\s\d{4}\s\d{4}$/.test(form.adhar_number)) {
      error.adhar_number = "Enter a valid 12-digit Aadhar Number";
    }
    // if (!form.adhar_image) {
    //   error.adhar_image = "Address Image required";
    // }

    setError(error);

    if (Object.keys(error).length === 0) {
      const formData = new FormData();

      formData.append("name", form?.name || "");
      formData.append("email", form?.email || "");
      formData.append("mobile_number", form?.mobile_number || "");
      if (userRole == "admin") {
        formData.append("base_salary", form?.base_salary || 0);
      }

      formData.append(
        "adhar_number",
        form?.adhar_number ? form.adhar_number.replace(/\s/g, "") : ""
      );
      if (form?.adhar_image instanceof File) {
        formData.append("adhar_image", form.adhar_image);
      }
      if (data) {
        updateEmployee(formData);
      } else {
        addEmployee(formData);
      }
    }
  };

  const addEmployee = (payload) => {
    setLoading(true);
    createEmployeeApi(payload)
      .then(() => {
        toast.success("Employee Added successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  const updateEmployee = (payload) => {
    setLoading(true);
    updateEmployeeApi(data?.id || "", payload)
      .then(() => {
        toast.success("Employee update successfully");
        onAfterSubmit();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => setLoading(false));
  };
  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{data ? "Update Employee" : "Add Employee"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-1">
          <div className="row g-2">
            <div className="col-md-6">
              <label className="form-label text-dark">Name</label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px", pointerEvents: "none" }}
                >
                  <GrUserWorker className="text-secondary" />
                </span>
                <input
                  type="text"
                  name="name"
                  className={`form-control px-5 ${
                    error?.name ? "is-invalid" : ""
                  }`}
                  value={form.name}
                  placeholder="e.g. John Deo"
                  onChange={handleInputChange}
                />
              </div>

              {error?.name && (
                <small className="text-danger">{error.name}</small>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label text-dark">Mobile Number</label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px", pointerEvents: "none" }}
                >
                  <FaPhone className="text-secondary" />
                </span>
                <input
                  type="text"
                  name="mobile_number"
                  className={`form-control px-5 ${
                    error?.mobile_number ? "is-invalid" : ""
                  }`}
                  value={form.mobile_number}
                  placeholder="e.g. 9777303064"
                  onChange={handleInputChange}
                />
              </div>

              {error?.mobile_number && (
                <small className="text-danger">{error.mobile_number}</small>
              )}
            </div>
            <div className="col-12">
              <label className="form-label text-dark">Email</label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px", pointerEvents: "none" }}
                >
                  <MdEmail className="text-secondary" />
                </span>
                <input
                  type="text"
                  name="email"
                  className={`form-control px-5 ${
                    error?.email ? "is-invalid" : ""
                  }`}
                  value={form.email}
                  placeholder="e.g. john@gmail.com"
                  onChange={handleInputChange}
                />
              </div>

              {error?.email && (
                <small className="text-danger">{error.email}</small>
              )}
            </div>
            {userRole == "admin" && (
              <div className="col-12">
                <label className="form-label text-dark">Expected Salary</label>
                <div className="position-relative">
                  <span
                    className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                    style={{ left: "15px", pointerEvents: "none" }}
                  >
                    <FaMoneyBill1Wave className="text-secondary" />
                  </span>
                  <input
                    type="text"
                    name="base_salary"
                    className={`form-control px-5 ${
                      error?.base_salary ? "is-invalid" : ""
                    }`}
                    value={form.base_salary}
                    placeholder="e.g. ₹14000"
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        handleInputChange(e);
                      }
                    }}
                  />
                </div>

                {error?.base_salary && (
                  <small className="text-danger">{error.base_salary}</small>
                )}
              </div>
            )}

            <div className="col-12">
              <label className="form-label text-dark fw-semibold">
                Aadhar Number
              </label>
              <div className="position-relative">
                <span
                  className="position-absolute top-50 translate-middle-y text-secondary icon-float"
                  style={{ left: "15px", pointerEvents: "none" }}
                >
                  <FaIdCard className="text-secondary" />
                </span>
                <input
                  type="text"
                  name="adhar_number"
                  maxLength="14"
                  className={`form-control px-5 ${
                    error?.adhar_number ? "is-invalid" : ""
                  }`}
                  value={form.adhar_number}
                  placeholder="XXXX XXXX XXXX"
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 0) {
                      value = value.match(/.{1,4}/g).join(" ");
                    }
                    handleInputChange({
                      target: { name: "adhar_number", value },
                    });
                  }}
                />
              </div>
              {error?.adhar_number && (
                <small className="text-danger">{error.adhar_number}</small>
              )}
            </div>

            <div className="col-12 mb-0">
              <label className="form-label text-dark">Adhar Image</label>
            </div>
            <div className="col-6 mt-0">
              <FileUpload
                label="Adhar Image"
                accept=".jpg,.jpeg,.png"
                multiple={false}
                value={form?.adhar_image}
                onChange={(files) => {
                  setForm((prev) => ({ ...prev, adhar_image: files }));
                  //   if (files) {
                  //     setError({ ...error, adhar_image: "" });
                  //   }
                }}
              />
              {/* {error?.adhar_image && (
                <small className="text-danger mb-3">{error.adhar_image}</small>
              )} */}
            </div>
            <div className="col-6 mt-0">
              <div
                className="card shadow-sm"
                style={{ height: "100px", overflow: "hidden" }}
              >
                {form?.adhar_image ? (
                  <img
                    src={
                      form?.adhar_image instanceof File
                        ? URL.createObjectURL(form.adhar_image)
                        : form?.adhar_image
                        ? `${process.env.REACT_APP_BASE_URL}${form.adhar_image}`
                        : null
                    }
                    alt="Adhar Preview"
                    style={{
                      objectFit: "contain",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                ) : (
                  <div
                    className="d-flex justify-content-center align-items-center h-100"
                    style={{
                      backdropFilter: "blur(4px)",
                      backgroundColor: "rgba(0,0,0,0.1)",
                    }}
                  >
                    <span className="text-secondary fw-semibold">
                      Image Not Available
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end gap-2 w-100">
          <button
            className="btn btn-outline-dark"
            disabled={loading}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading && <Spinner animation="border" size="sm" />} Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddEmployeeModal;
